import { useTranslation } from 'react-i18next';

import { Breadcrumbs } from '@unified-checkout/design-system';

import { useSettingsUtils } from '../../Settings/useSettingsUtils';

import styles from './header.module.scss';

const Header = () => {
  const { t } = useTranslation();
  const { internalPagesBreadcrumbs } = useSettingsUtils();

  return (
    <div className={styles['header']}>
      <Breadcrumbs linksProps={internalPagesBreadcrumbs.API_KEYS} />
      <div className={styles['header__content']}>
        <div className={styles['header__content-title']}>
          {t('innerLayout.settingsPage.developersCards.apiKeys.title')}
        </div>
        <div className={styles['header__content-subtitle']}>
          {t('innerLayout.settingsPage.developersCards.apiKeys.desc')}
        </div>
      </div>
    </div>
  );
};

export default Header;
